import { render } from "./ProfileDropdown.vue?vue&type=template&id=bcd38efa&ts=true"
import script from "@/composables/layouts/navigation/profileDropdownComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/layouts/navigation/profileDropdownComposable.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__